<template>
  <span>{{ formatted }}</span>
</template>

<script>
export default {
  name: "proofCosts",
  props: ["item"],
  computed: {
    formatted() {
      const n = Number(this.item && this.item.costs);
      const value = isNaN(n) ? 0 : n;
      return value.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
